import { useGetDataPot } from "api/useGetDataPot";
import contract from "assets/contract.svg";
import desktopImage from "assets/img_1.png";
import mobileImageTop from "assets/img_2.png";
import mobileImageBottom from "assets/img_3.png";
import lines from "assets/lines.svg";
import React from "react";
import { Helmet } from "react-helmet";

import { calculateOdds } from "./odds";
import OddsArtwork from "./OddsArtwork";

const Awards = () => {
  const { data } = useGetDataPot();
  const odds = calculateOdds(data?.ball_choice, data?.mega_ball_choice);
  return (
    <div className="mt-[93px] z-0">
      <Helmet>
        <title>Megaball | Шагналын сан</title>
      </Helmet>
      <div className="flex bg-[#0048A6] justify-center relative z-0 overflow-hidden h-[100px] items-center">
        <p className="font-bold text-4xl text-black0 text-center md:text-[32px]">
          Шагналын сан
        </p>
        <img
          alt=""
          src={lines}
          className="object-cover absolute right-0 bottom-0 pointer-events-none"
        />
      </div>

      <div className="bg-black10 py-16 relative flex justify-center">
        <div className="flex md:flex-col">
          <div className="hidden md:block">
            <p className="text-center text-xl text-black70 font-bold">
              Хонжворын дүн
            </p>
          </div>

          <div className="flex flex-col justify-center relative pt-8">
            <div className="flex-row flex">
              <div>
                <div className="flex flex-row justify-around flex-1 mb-2"></div>

                {/* Desktop */}
                <OddsArtwork
                  odds={odds}
                  src={desktopImage}
                  className="relative z-10 pointer-events-none max-w-[900px] w-full md:hidden"
                />

                {/* Mobile */}
                <div className="hidden w-full px-4 md:flex md:flex-col ">
                  <img
                    alt=""
                    src={mobileImageTop}
                    className=" pointer-events-none w-full"
                  />
                  <OddsArtwork
                    mobile
                    odds={odds}
                    src={mobileImageBottom}
                    className="pointer-events-none self-center mt-10 max-w-[300px] w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          alt=""
          src={contract}
          className="absolute pointer-events-none z-0 left-0 top-0 md:hidden"
        />
      </div>
    </div>
  );
};

export default Awards;
